// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "316d8339784da81bd0a57c97216f3c7b26f77277/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};